(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-chopper-interactive-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!window.mphiHotspotsInit) {
    window.mphiHotspotsInit = function (scope) {
      scope.querySelectorAll('[data-mphi]:not([data-ready])').forEach(function (root) {
        var dots = Array.from(root.querySelectorAll('[data-dot]'));
        var cards = Array.from(root.querySelectorAll('[data-card]'));
        var stage = root.querySelector('.mphi__stage');
        var desktop = window.matchMedia('(min-width: 990px)');
        var selected = cards[0] && cards[0].dataset.card;
        function select(id) {
          selected = id;
          cards.forEach(function (card) { card.classList.toggle('is-active', card.dataset.card === selected); });
          dots.forEach(function (dot) {
            dot.setAttribute('aria-expanded', String(desktop.matches || root.dataset.mobileMode === 'all' || dot.dataset.dot === selected));
            dot.tabIndex = desktop.matches ? -1 : 0;
          });
        }
        function draw() {
          if (!root.isConnected || !desktop.matches) return;
          var svg = root.querySelector('.mphi__lines');
          var matrix = svg.getScreenCTM();
          if (!matrix) return;
          var inverse = matrix.inverse();
          function point(x, y) {
            var p = svg.createSVGPoint();
            p.x = x; p.y = y;
            return p.matrixTransform(inverse);
          }
          dots.forEach(function (dot) {
            var id = dot.dataset.dot;
            var card = cards.find(function (item) { return item.dataset.card === id; });
            if (!card) return;
            var a = dot.getBoundingClientRect();
            var b = card.getBoundingClientRect();
            var dotX = a.left + a.width / 2;
            var cardX = b.left + b.width / 2 < dotX ? b.right : b.left;
            var start = point(dotX, a.top + a.height / 2);
            var finish = point(cardX, b.top + b.height / 2);
            var elbow = finish.x + (start.x - finish.x) * .4;
            root.querySelector('[data-line="' + id + '"]').setAttribute('points', start.x + ',' + start.y + ' ' + elbow + ',' + finish.y + ' ' + finish.x + ',' + finish.y);
            var end = root.querySelector('[data-end="' + id + '"]');
            end.setAttribute('cx', finish.x); end.setAttribute('cy', finish.y);
          });
        }
        dots.forEach(function (dot) { dot.addEventListener('click', function () { select(dot.dataset.dot); }); });
        root.addEventListener('shopify:block:select', function (event) { if (event.detail.blockId) select(event.detail.blockId); });
        var observer = new ResizeObserver(draw);
        observer.observe(stage);
        cards.forEach(function (card) { observer.observe(card); });
        var change = function () { select(selected); requestAnimationFrame(draw); };
        desktop.addEventListener('change', change);
        var unload = function (event) {
          if (!event.target.contains(root)) return;
          observer.disconnect(); desktop.removeEventListener('change', change); document.removeEventListener('shopify:section:unload', unload);
        };
        document.addEventListener('shopify:section:unload', unload);
        root.setAttribute('data-ready', '');
        select(selected); requestAnimationFrame(draw);
        if (document.fonts) document.fonts.ready.then(draw);
      });
    };
    document.addEventListener('shopify:section:load', function (event) { window.mphiHotspotsInit(event.target); });
  }
  window.mphiHotspotsInit(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-chopper-set-offer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mp-set-offer')){
 customElements.define('mp-set-offer',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const form=this.querySelector('form');if(!form)return;
   const colors=this.querySelector('.mp-set__colors');
   const warmSets=()=>{this.querySelectorAll('.mp-set__set[hidden] .mp-set__set-img').forEach(img=>{img.loading='eager';});};
   if('IntersectionObserver' in window){
    const observer=new IntersectionObserver((entries)=>{if(entries.some(entry=>entry.isIntersecting)){warmSets();observer.disconnect();}},{rootMargin:'300px'});
    observer.observe(this);
   }else{warmSets();}
   if(colors){colors.addEventListener('change',(event)=>{
    const input=event.target;if(!input.matches('.mp-set__color-input')||input.disabled||this.busy)return;
    const sets=Array.from(this.querySelectorAll('[data-set-color]'));
    const selectedSet=sets.find(set=>set.dataset.setColor===input.dataset.imageKey)||sets.find(set=>set.dataset.setColor==='default');
    if(selectedSet){sets.forEach(set=>{set.hidden=set!==selectedSet;});}
    form.querySelector('[name="id"]').value=input.value;
    this.querySelector('.mp-set__price bdi').textContent=input.dataset.price;
    this.querySelector('.mp-set__headline-price').textContent='ב־'+input.dataset.price;
    const compare=this.querySelector('.mp-set__compare');compare.hidden=!input.dataset.compare;compare.querySelector('bdi').textContent=input.dataset.compare;
    const copy=form.querySelector('.mp-set__button-copy');copy.replaceChildren();
    const title=document.createElement('span');title.textContent=this.dataset.buttonLabel;
    const price=document.createElement('small');price.textContent='ב־'+input.dataset.price;
    copy.append(title,price);form.querySelector('[name="add"]').disabled=false;
    form.querySelector('.mp-set__error').hidden=true;
   });}

   form.addEventListener('submit',async(event)=>{
    event.preventDefault();if(this.busy)return;
    const button=form.querySelector('[name="add"]');if(button.disabled)return;
    const error=form.querySelector('.mp-set__error');const label=button.querySelector('.mp-set__button-copy');const original=label.innerHTML;
    const drawer=document.querySelector('cart-drawer');const variantId=form.querySelector('[name="id"]').value;
    if(!variantId)return;
    this.busy=true;if(colors)colors.disabled=true;button.disabled=true;button.setAttribute('aria-busy','true');error.hidden=true;label.textContent=this.dataset.loading;
    const payload={items:[{id:variantId,quantity:1}]};
    if(drawer){payload.sections='cart-drawer,cart-icon-bubble';payload.sections_url=window.location.pathname;}
    try{
     const root=window.Shopify?.routes?.root||'/';
     const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
     const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||this.dataset.error);
     if(window.PUB_SUB_EVENTS&&typeof publish==='function'){publish(PUB_SUB_EVENTS.cartUpdate,{source:'mp-set-offer',productVariantId:variantId,cartData:data});}
     if(drawer&&data.sections&&typeof drawer.renderContents==='function'){
      drawer.setActiveElement?.(button);drawer.classList.remove('is-empty');drawer.renderContents(data);
     }else{window.location.assign(root+'cart');}
    }catch(exception){error.textContent=exception.message||this.dataset.error;error.hidden=false;}
    finally{this.busy=false;if(colors)colors.disabled=false;button.disabled=false;button.removeAttribute('aria-busy');label.innerHTML=original;}
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mp-photo-reviews')) {
    customElements.define('mp-photo-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const dialog = this.querySelector('.mp-photo-reviews__dialog');
        const holder = this.querySelector('.mp-photo-reviews__dialog-image');
        const writeModal = document.getElementById(this.id + '-write');
        const grid = this.querySelector('.mp-photo-reviews__grid');
        const dotsBox = this.querySelector('.mp-photo-reviews__dots');
        if (grid && dotsBox) {
          const cards = Array.from(grid.querySelectorAll('.mp-photo-reviews__card'));
          if (cards.length > 1) {
            dotsBox.innerHTML = cards.map(() => '<span></span>').join('');
            const dots = Array.from(dotsBox.children);
            const paint = () => {
              let best = 0;
              if (Math.abs(grid.scrollLeft) + grid.clientWidth >= grid.scrollWidth - 2) {
                best = cards.length - 1;
              } else {
                const edge = grid.getBoundingClientRect().right;
                let bestD = Infinity;
                cards.forEach((card, i) => {
                  const d = Math.abs(card.getBoundingClientRect().right - edge);
                  if (d < bestD) { bestD = d; best = i; }
                });
              }
              dots.forEach((dot, i) => dot.classList.toggle('is-on', i === best));
            };
            let timer;
            grid.addEventListener('scroll', () => { clearTimeout(timer); timer = setTimeout(paint, 60); }, { passive: true });
            paint();
          }
        }
        this.addEventListener('shopify:block:select', event => {
          const all = event.target.closest && event.target.closest('.mp-photo-reviews__all');
          if (all) all.open = true;
        });
        if (writeModal) {
          writeModal.addEventListener('click', event => {
            if (event.target === writeModal || event.target.closest('[data-write-close]')) writeModal.classList.remove('is-open');
          });
          document.addEventListener('keydown', event => {
            if (event.key === 'Escape') writeModal.classList.remove('is-open');
          });
        }
        this.addEventListener('click', event => {
          if (writeModal && event.target.closest('[data-write-review]')) {
            writeModal.classList.add('is-open');
            return;
          }
          const opener = event.target.closest('[data-photo]');
          if (opener && dialog && holder) {
            const source = opener.querySelector('img');
            if (!source) return;
            const img = source.cloneNode();
            img.removeAttribute('loading');
            img.removeAttribute('sizes');
            img.removeAttribute('srcset');
            img.removeAttribute('class');
            holder.replaceChildren(img);
            dialog.showModal();
          }
          if (dialog && event.target.closest('[data-close]')) dialog.close();
          if (dialog && event.target === dialog) {
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-review-distribution"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mp-review-distribution')) {
    customElements.define('mp-review-distribution', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.cards = Array.from(this.querySelectorAll('[data-review]'));
        this.mq = window.matchMedia('(max-width: 749px)');
        this.readSizes();
        this.limit = this.pageSize;
        this.rating = '';
        this.photos = false;
        this.verified = false;
        this.order = 'newest';
        this.filter = 'all';
        this.list = this.querySelector('.mprd__list');
        this.status = this.querySelector('[data-status]');
        this.more = this.querySelector('[data-more]');
        this.less = this.querySelector('[data-less]');
        this.dialog = this.querySelector('[data-photo-dialog]');
        this.querySelector('[data-tools]').hidden = false;
        this.filterDialog = this.querySelector('[data-filter-dialog]');
        this.filterToggle = this.querySelector('[data-filter-toggle]');
        this.cards.forEach(card => {
          const date = this.reviewDate(card);
          const time = card.querySelector('time');
          if (time && date !== null) time.textContent = new Intl.DateTimeFormat('he-IL', {day:'numeric', month:'long', year:'numeric', timeZone:'UTC'}).format(new Date(date));
        });
        const reset = () => {
          this.filter = 'all';
          this.rating = '';
          this.photos = false;
          this.limit = this.pageSize;
          this.update();
        };
        this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
          this.filter = button.dataset.filter;
          this.rating = /^[1-5]$/.test(this.filter) ? this.filter : '';
          this.photos = this.filter === 'photos';
          this.limit = this.pageSize;
          this.update();
        }, {signal}));
        this.querySelectorAll('[data-order]').forEach(button => button.addEventListener('click', () => {
          this.order = button.dataset.order;
          this.limit = this.pageSize;
          this.update();
        }, {signal}));
        this.querySelector('[data-reset]').addEventListener('click', () => { reset(); this.filterToggle.focus(); }, {signal});
        this.filterToggle.addEventListener('click', () => {
          if (this.filterDialog.open) { this.filterDialog.close(); return; }
          if (this.mq.matches) this.filterDialog.showModal();
          else { this.filterDialog.show(); this.positionFilter(); }
          this.filterToggle.setAttribute('aria-expanded','true');
          this.filterDialog.querySelector('[data-filter][aria-pressed="true"]')?.focus({preventScroll:true});
        }, {signal});
        this.querySelector('[data-close-filter]').addEventListener('click', () => this.filterDialog.close(), {signal});
        this.filterDialog.addEventListener('close', () => {
          this.filterToggle.setAttribute('aria-expanded','false');
          this.filterToggle.focus({preventScroll:true});
        }, {signal});
        document.addEventListener('pointerdown', event => {
          if (!this.filterDialog.open || this.filterToggle.contains(event.target)) return;
          const box = this.filterDialog.getBoundingClientRect();
          if (!this.filterDialog.contains(event.target) || (event.target === this.filterDialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom))) this.filterDialog.close();
        }, {signal});
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.filterDialog.open) { event.preventDefault(); this.filterDialog.close(); }
        }, {signal});
        window.addEventListener('resize', () => { if (this.filterDialog.open) this.filterDialog.close(); }, {signal});
        window.addEventListener('scroll', () => { if (this.filterDialog.open && !this.mq.matches) this.positionFilter(); }, {signal, capture:true, passive:true});
        this.more.addEventListener('click', () => {
          const next = this.filtered[this.limit];
          this.limit = Math.min(this.limit + this.step, this.filtered.length);
          this.update();
          next?.focus({preventScroll:true});
        }, {signal});
        this.less.addEventListener('click', () => {
          const buttonTop = this.less.getBoundingClientRect().top;
          this.limit = this.pageSize;
          this.update();
          if (!this.more.hidden) {
            const offset = this.more.getBoundingClientRect().top - buttonTop;
            window.scrollBy({top: offset, left: 0, behavior: 'instant'});
            this.more.focus({preventScroll:true});
          }
        }, {signal});
        this.mq.addEventListener('change', () => {
          const expanded = this.limit > this.pageSize;
          this.readSizes();
          if (!expanded) this.limit = this.pageSize;
          this.update();
        }, {signal});
        this.querySelectorAll('[data-photo-link]').forEach(link => link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !this.dialog.showModal) return;
          event.preventDefault();
          this.photoTrigger = link;
          const img = this.dialog.querySelector('[data-dialog-image]');
          img.src = link.href;
          img.alt = link.querySelector('img').alt;
          this.dialog.showModal();
        }, {signal}));
        this.querySelector('[data-close-dialog]').addEventListener('click', () => this.dialog.close(), {signal});
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, {signal});
        this.dialog.addEventListener('close', () => this.photoTrigger?.focus(), {signal});
        this.writeDialog = this.querySelector('[data-write-dialog]');
        this.querySelector('[data-write-review]')?.addEventListener('click', event => {
          this.dispatchEvent(new CustomEvent('mypalora:write-review', {bubbles:true, detail:{sectionId:this.id}}));
          if (!this.writeDialog?.showModal) return;
          event.preventDefault();
          this.writeTrigger = event.currentTarget;
          this.writeDialog.showModal();
        }, {signal});
        this.querySelectorAll('[data-close-write]').forEach(button => button.addEventListener('click', () => this.writeDialog.close(), {signal}));
        this.writeDialog?.addEventListener('click', event => { if (event.target === this.writeDialog) this.writeDialog.close(); }, {signal});
        this.writeDialog?.addEventListener('close', () => this.writeTrigger?.focus({preventScroll:true}), {signal});
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
          if (!card) return;
          reset();
          this.limit = this.cards.length;
          this.update();
          card.scrollIntoView({block:'center',behavior:'auto'});
        }, {signal});
        this.update();
      }
      readSizes() {
        const mobile = this.mq.matches;
        const read = (value, fallback) => { const n = Number(value); return n > 0 ? n : fallback; };
        this.pageSize = read(mobile ? this.dataset.pageMobile : this.dataset.pageDesktop, mobile ? 4 : 6);
        this.step = read(mobile ? this.dataset.stepMobile : this.dataset.stepDesktop, this.pageSize);
      }
      update() {
        const ordered = this.cards.slice();
        const byDate = (a,b,ascending=false) => {
          const da = this.reviewDate(a), db = this.reviewDate(b);
          if (da === null && db === null) return 0;
          if (da === null) return 1;
          if (db === null) return -1;
          return ascending ? da-db : db-da;
        };
        ordered.sort((a,b) => {
          if (this.order === 'low') return Number(a.dataset.score)-Number(b.dataset.score) || byDate(a,b);
          if (this.order === 'high') return Number(b.dataset.score)-Number(a.dataset.score) || byDate(a,b);
          return byDate(a,b,this.order === 'oldest');
        });
        this.filtered = ordered.filter(card => (!this.rating || card.dataset.score === this.rating) && (!this.photos || card.dataset.hasPhoto === 'true'));
        const visible = new Set(this.filtered.slice(0,this.limit));
        ordered.forEach(card => {card.hidden = !visible.has(card);this.list.appendChild(card);});
        this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.filter === this.filter)));
        this.querySelectorAll('[data-order]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.order === this.order)));
        this.querySelector('[data-empty]').hidden = this.filtered.length > 0;
        this.more.hidden = this.limit >= this.filtered.length;
        this.less.hidden = Math.min(this.limit, this.filtered.length) <= this.pageSize;
        if (this.status) this.status.textContent = 'מוצגות ' + visible.size + ' מתוך ' + this.filtered.length + ' ביקורות';
      }
      reviewDate(card) {
        const raw = card.dataset.date || '';
        if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return null;
        const value = Date.parse(raw + 'T00:00:00Z');
        return Number.isFinite(value) && new Date(value).toISOString().slice(0,10) === raw ? value : null;
      }
      positionFilter() {
        const dialog = this.filterDialog;
        const box = this.filterToggle.getBoundingClientRect();
        dialog.style.maxHeight = Math.max(160, window.innerHeight-24)+'px';
        const width = dialog.offsetWidth;
        const height = dialog.offsetHeight;
        dialog.style.left = Math.max(12,Math.min(box.right-width,window.innerWidth-width-12))+'px';
        dialog.style.top = Math.max(12,Math.min(box.bottom+8,window.innerHeight-height-12))+'px';
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        if (this.filterDialog?.open) this.filterDialog.close();
        if (this.writeDialog?.open) this.writeDialog.close();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mypalora-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mp-announcement')) {
  customElements.define('mp-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.mpReady) return;
      this.mpReady = true;
      const button = this.querySelector('.mp-ann__close');
      if (button) button.addEventListener('click', () => { this.hidden = true; });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
